import sanitizeHtml from 'sanitize-html';
export var sanitizeResponsibilityHtml = function sanitizeResponsibilityHtml(responsibilities) {
  var sanitizedResponsibilities = {};
  sanitizeHtml(responsibilities, {
    allowedTags: ['li'],
    textFilter: function textFilter(text) {
      return text.replaceAll(/&amp;/g, '&');
    }
  }).replaceAll(/<li>/g, '').split('</li>').forEach(function (v, i) {
    sanitizedResponsibilities[i] = {
      description: v
    };
  });
  return sanitizedResponsibilities;
};
export var responsibilitiesToListElements = function responsibilitiesToListElements(responsibilities) {
  return responsibilities.map(function (res) {
    return "<li>".concat(res.description, "</li>");
  }).join('');
};
export var sanitizeOnChangeValue = function sanitizeOnChangeValue(responsibilities) {
  return sanitizeHtml(responsibilities, {
    allowedTags: ['li']
  });
};
export var listElementsToArray = function listElementsToArray(idealCandidate) {
  if (Array.isArray(idealCandidate)) return idealCandidate.filter(Boolean);
  if (!idealCandidate || typeof idealCandidate !== 'string') return [];
  return idealCandidate.replaceAll(/<li>/g, '').replaceAll(/&amp;/g, '&').split('</li>').filter(Boolean);
};
export var formatIdealCandidateOnLoad = function formatIdealCandidateOnLoad(idealCandidate) {
  if (!idealCandidate || typeof idealCandidate !== 'string') return null;
  if (!idealCandidate.includes('<li>')) return "<li>".concat(idealCandidate, "</li>");
  return idealCandidate;
};
export var decodeAmpersands = function decodeAmpersands(inputText) {
  if (!inputText || typeof inputText !== 'string') return inputText;
  return inputText.replaceAll(/&amp;(?:amp;)?/g, '&');
};